import type { Nullable } from '@utils/types/Nullable';
import type { TCandidate } from '@model/Candidate/Candidate.type';
import { minutesToHours } from 'date-fns';
import i18n from '@app/i18n';
import { Parser } from 'html-to-react';
import type { ReactNode } from 'react';

const htmlParser = new Parser();

export const getDrivingTimeToWorkContent = (
  candidate: Nullable<TCandidate>,
): Nullable<ReactNode> => {
  if (!candidate || !candidate.drivingTimeToWorkInMinutes) {
    return null;
  }

  const { drivingTimeToWorkInMinutes } = candidate;

  const hours = minutesToHours(drivingTimeToWorkInMinutes) || null;
  const minutes = drivingTimeToWorkInMinutes - (hours ?? 0) * 60;

  const hoursContent = hours
    ? i18n.t('candidateDetails.info.drivingTime.hours', {
        hours,
      })
    : null;

  const minutesContent = minutes
    ? i18n.t('candidateDetails.info.drivingTime.minutes', {
        minutes,
      })
    : null;

  return htmlParser.parse(
    [hoursContent, minutesContent].filter(segment => !!segment).join(' '),
  );
};
